import ClubFinancialAccountingDatevSettings from '../dto/ClubFinancialAccountingDatevSettings';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubFinancialAccountingSettingsRepository {
    static getDatevSettings(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/financial-accounting/datev-settings`)
                .then((response) => resolve(ClubFinancialAccountingDatevSettings.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static updateDatevSettings(clubId, datevSettings) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/financial-accounting/datev-settings`, datevSettings.serialize())
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
